import {
  Box,
  Button,
  Card,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IExpense } from '../../../../shared/interfaces/expenses/IExpense';
import { RootState } from '../../../../store/store';

interface IProps {
  isUpdate?: boolean;
  control: Control<IExpense>;
}
const ExpenseForm = ({ control, isUpdate = false }: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { expensesType } = useSelector((state: RootState) => state.enums);
  return (
    <Card>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name={'name'}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                error={!!error?.message}
                helperText={error?.message}
                value={value ?? ''}
                onChange={onChange}
                label={t('general.expenseName')}
                sx={{ width: '100%' }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name={'amount'}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                error={!!error?.message}
                helperText={error?.message}
                value={value ?? ''}
                onChange={onChange}
                label={t('expenses.price')}
                sx={{ width: '100%' }}
                type={'number'}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name={'expenseType'}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <FormControl fullWidth>
                <InputLabel
                  className={!!error?.message?.length ? 'Mui-error' : ''}
                  id="status-label"
                >
                  {t('general.type')}
                </InputLabel>
                <Select
                  error={!!error?.message}
                  labelId="status-label"
                  id="status-select"
                  value={value ?? ''}
                  label={t('general.type')}
                  onChange={onChange}
                >
                  {expensesType.map((type) => {
                    return (
                      <MenuItem key={type} value={type}>
                        {t(`expenses.type.${type}`)}
                      </MenuItem>
                    );
                  })}
                </Select>
                {!!error?.message?.length && (
                  <FormHelperText>{error?.message}</FormHelperText>
                )}
              </FormControl>
            )}
          />
        </Grid>
        <Grid size={12}>
          <Controller
            name={'description'}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                error={!!error?.message}
                helperText={error?.message}
                value={value ?? ''}
                onChange={onChange}
                label={t('general.description')}
                sx={{ width: '100%' }}
                multiline
                rows={4}
              />
            )}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant={'contained'}
          color={'secondary'}
          sx={{ marginTop: '20px' }}
          type={'button'}
          onClick={() => navigate(-1)}
        >
          {t('button.cancel')}
        </Button>
        <Button
          variant={'contained'}
          sx={{ margin: '20px 0 0 10px' }}
          type={'submit'}
        >
          {t(isUpdate ? 'button.update' : 'button.create')}
        </Button>
      </Box>
    </Card>
  );
};

export default ExpenseForm;
